import {
  Button,
  getPrimaryColor,
  isMobileAtom,
  Styles,
  Tag,
  useRecoil,
} from '@orcar/common-d2c';
import styled from 'styled-components';
import { app } from '@/constants/common';

type LongTermVehicleTag = {
  text: string;
};

type LongTermVehicleCardProps = {
  tagList: LongTermVehicleTag[];
  imgUrl: string;
  vehicleModelName: string;
  monthPrice?: number;
  onClick: () => void;
};

const LongTermVehicleCard = ({
  tagList,
  imgUrl,
  vehicleModelName,
  monthPrice,
  onClick,
}: LongTermVehicleCardProps) => {
  const { recoilValue: isMobile } = useRecoil(isMobileAtom);
  return (
    <Wrapper onClick={onClick} isMobile={isMobile}>
      <InnerWrapper>
        <TagWrapper>
          {tagList.map((tag, index) => (
            <Tag
              key={index}
              text={tag.text}
              padding='4px 8px'
              borderRadius={Styles.BORDER_RADIUS.LEVEL_01}
              font={Styles.FONT.B2}
              renewal
            />
          ))}
        </TagWrapper>
        <img src={imgUrl} width={'100%'} alt={vehicleModelName} />
        <Text fontSize={16} fontWeight={600}>
          {vehicleModelName}
        </Text>
        <Text fontSize={20} fontWeight={700} color={getPrimaryColor(app)}>
          {monthPrice ? `월 ${monthPrice.toLocaleString()}원~` : '상담 후 결정'}
        </Text>
      </InnerWrapper>
      <Button
        borderRadius={Styles.BORDER_RADIUS.LEVEL_01}
        height='40px'
        font={Styles.NEW_FONT.B1}
      >
        견적받기
      </Button>
    </Wrapper>
  );
};

export default LongTermVehicleCard;

const Wrapper = styled.div<{ isMobile: boolean }>`
  display: flex;
  flex-direction: column;
  justify-content: space-between;
  gap: 28px;
  padding: 20px;
  width: ${({ isMobile }) => (isMobile ? '100%' : '380px')};
  background-color: ${({ theme }) => theme.COLOR.WHITE};
  cursor: pointer;
  border-radius: 10px;
  box-shadow: ${({ theme }) => theme.BOX_SHADOW.LEVEL_02};
`;

const InnerWrapper = styled.div`
  display: flex;
  flex-direction: column;
  gap: 8px;
`;

const Text = styled.p<{
  font?: Record<string, string>;
  fontSize?: number;
  fontWeight?: number;
  color?: string;
}>`
  font-size: ${({ fontSize }) => (fontSize ? `${fontSize}px` : '16px')};
  font-weight: ${({ fontWeight }) => (fontWeight ? `${fontWeight}` : '400')};
  ${({ font }) => font && font};
  color: ${({ color, theme }) => color || theme.COLOR.GREY_01};
`;

const TagWrapper = styled.div`
  display: flex;
  gap: 8px;
`;
